"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createApi = require("../createApi");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(types, request) {
  return function (payload) {
    var _ref;

    return _ref = {}, _defineProperty(_ref, _createApi.symbol, true), _defineProperty(_ref, "request", request), _defineProperty(_ref, "payload", payload), _defineProperty(_ref, "types", types), _ref;
  };
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-future-middleware/lib/helpers/createAction.js
// module id = 1224
// module chunks = 0